import { render, staticRenderFns } from "./StaffGroupSettings.vue?vue&type=template&id=c50b1c62&"
import script from "./StaffGroupSettings.vue?vue&type=script&lang=js&"
export * from "./StaffGroupSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports